import { defaultReducers, defaultInitialState, IDefaultState } from "../../../../../redux/_common";
import { createSlice, PayloadAction } from "@reduxjs/toolkit";


const initialState = {...defaultInitialState};
const reducers = {
  ...defaultReducers,
  coutriesFetched: (state:any, action:PayloadAction) => {
    state.listLoading = false;
    state.countries = action.payload;
  },
  setValidationErrors: (state: any, action: PayloadAction<any>) => {
    state.validationErrors = action.payload;
  },
};

export const territoriesSlice = createSlice({
  name: "territories",
  initialState,
  reducers,
});

